export enum GroupColumn {
    unitDetails = "Unit Details",
    contacts = "Contacts",
    milestones = "Milestones",
}

export type GroupColumnSelectedType = GroupColumn

export enum RoutesUnion {
    Contacts = "/contacts",
    Milestones = "/milestones",
    Notes = "/notes",
    Owners = "/owners",
    Location = "/location",
}

export interface RouteAndType {
    route: string
    tabType: GroupColumnSelectedType
}

export const RouteList: Array<RouteAndType> = [
    { route: RoutesUnion.Contacts, tabType: GroupColumn.contacts },
    { route: RoutesUnion.Milestones, tabType: GroupColumn.milestones },
    { route: "/", tabType: GroupColumn.unitDetails },
]

export enum MilestoneTaskQuery {
    previousListing = "previous_listing",
    earlyVisualsImages = "early_visuals_images",
}
